// creates async function which requests cachedDataStreams until all the data for viewport is present
export const fetchTimeSeriesData = (siteWiseTimeSeriesModule) => async ({ query, viewport, settings, }) => {
    return new Promise((resolve) => {
        siteWiseTimeSeriesModule.getCachedDataStreams({
            queries: [query],
            viewport,
            settings,
            emitDataStreams: (ds) => resolve(ds),
        });
    });
};
